import React from 'react'
import { connect } from 'react-redux'
import Group from 'components/utils/Group'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer'
import { getSupportContact } from 'selectors/supportContactSelector'

interface Props {
  supportContact: App.GeoContact;
}

function MultipleCabinsCallUs({ supportContact }: Props) {
  return (
    <LayoutContainer>
      <Group gap={0} tabletGap={8} direction="vertical">
        <Heading variant="heading6">
          Need to book multiple cabins?
        </Heading>
        <Group direction="vertical" desktopDirection="horizontal" gap="12 0" desktopGap="0 12">
          <BodyText variant="medium" colour="neutral-three">
            Call our customer service team 24 hours, 7 days.
          </BodyText>
          <TextLink
            startIcon={<LinePhoneIcon />}
            size="medium"
            href={`tel:${supportContact.number}`}
          >
            {supportContact.humanReadable}
          </TextLink>
        </Group>
      </Group>
    </LayoutContainer>
  )
}

function mapStateToProps(state: App.State) {
  const supportContact = getSupportContact(state)
  return {
    supportContact: supportContact[supportContact.default],
  }
}

export default connect(mapStateToProps)(MultipleCabinsCallUs)
